module.exports = __webpack_public_path__ + "img/logos.257462ea.png";